"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "State Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "e.g. Maharashtra",
      maxlength: "50",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "State Code",
      prop: "code"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "e.g. MH",
      maxlength: "2",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "code", $$v);
      },
      expression: "formData.code"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Country",
      prop: "countryId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "Select Country",
      filterable: ""
    },
    model: {
      value: _vm.formData.countryId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "countryId", $$v);
      },
      expression: "formData.countryId"
    }
  }, _vm._l(_vm.countries, function (country) {
    return _c("el-option", {
      key: country.id,
      attrs: {
        label: country.name,
        value: country.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Priority",
      prop: "priority"
    }
  }, [_c("el-input-number", {
    attrs: {
      min: 1
    },
    model: {
      value: _vm.formData.priority,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "priority", $$v);
      },
      expression: "formData.priority"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "success",
      loading: _vm.loading
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" Save ")]), _c("el-button", {
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;